import { useDispatch } from "react-redux";
import {
  Notification,
  addNotification as AddNotificationAction
} from "store/notification";

export type NewNotification = {
  id?: Notification["id"];
} & Omit<Notification, "id">;

export enum DISMISS {
  _TESTING_ONLY = 200,
  FAST = 3000,
  DEFAULT = 5000,
  SLOW = 8000,
  USER_ONLY = "USER_ONLY",
  NOT_DISMISSIBLE = "NOT_DISMISSIBLE"
}

export const useNotification = (): [React.Dispatch<NewNotification>] => {
  const dispatch = useDispatch();

  const addNotification = (notification: NewNotification): void => {
    dispatch(
      AddNotificationAction({
        id: notification.id || "" + Math.floor(Math.random() * 9999999),
        ...notification
      })
    );
  };

  return [addNotification];
};
export * from "./Notifications";
